export enum SchemaTypes {
  ADVISER = 'adviser',
  SAVEADVISER = 'saveAdviser',
  ASHES_DELIVERY ='ashesDelivery'
}
